import {
    assign,
    literal,
    nullable,
    number,
    optional,
    string,
    type,
} from "superstruct";

import InstagramBaseLayoutSchema from "./InstagramBaseLayoutSettingsSchema";

const InstagramGridLayoutSettingsSchema = assign(
    type({
        label: nullable(string()),
        layout: literal("grid"),
        space: number(),
        columns: number(),
        rows: number(),
        minColumnsCount: optional(nullable(number())),
    }),
    InstagramBaseLayoutSchema
);

export default InstagramGridLayoutSettingsSchema;
